/*
 * research-note.js
 * ママノ・カカオ研究ノート用の最小限の JavaScript。
 *
 * 方針: 記事は JS 無効でも完全に読める（用語解説は <details> でネイティブ開閉、
 * 表は CSS の overflow-x で横スクロール可能）。この JS は「横スクロールできる表に
 * 気づけるようにする」進捗ヒントの装飾強化のみで、無効でも情報の欠落は起きない。
 */
(function () {
  'use strict';

  function enhanceTable(wrap) {
    // 横スクロール可能な表をキーボードでも操作できるようにする
    if (!wrap.hasAttribute('tabindex')) {
      wrap.setAttribute('tabindex', '0');
    }
    if (!wrap.getAttribute('role')) {
      wrap.setAttribute('role', 'region');
    }

    var update = function () {
      var scrollable = wrap.scrollWidth - wrap.clientWidth > 2;
      var atStart = wrap.scrollLeft <= 1;
      var atEnd = wrap.scrollLeft >= wrap.scrollWidth - wrap.clientWidth - 1;
      wrap.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
      wrap.setAttribute('data-at-start', atStart ? 'true' : 'false');
      wrap.setAttribute('data-at-end', atEnd ? 'true' : 'false');
    };

    update();
    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function init() {
    var wraps = document.querySelectorAll('.mc-rnote__table-wrap');
    for (var i = 0; i < wraps.length; i++) {
      enhanceTable(wraps[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
